
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 422.781 422.781"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M363.79 239.864l-14.57-138.769c-3.373-32.141-30.476-56.545-62.791-56.545h-36.347V26.685h13.664c3.238 0 6.275 1.6 8.119 4.278a13.332 13.332 0 0010.998 5.771c2.611 0 5.248-.764 7.562-2.357 6.067-4.182 7.596-12.491 3.414-18.558A36.547 36.547 0 00263.746 0H159.034a36.549 36.549 0 00-30.092 15.819c-4.182 6.066-2.654 14.376 3.414 18.558 6.066 4.182 14.377 2.652 18.557-3.414a9.868 9.868 0 018.121-4.278h13.664V44.55h-36.344c-32.322 0-59.426 24.41-62.795 56.556l-14.57 139.012a63.171 63.171 0 001.789 22.86l14.572 54.603c5.906 22.131 23.141 38.858 44.459 44.646l-15.006 42.795c-2.438 6.953 1.223 14.568 8.178 17.006 1.461.514 2.949.754 4.414.754 5.51 0 10.666-3.438 12.592-8.93l17.324-49.412h128.156l17.326 49.412c1.926 5.492 7.082 8.93 12.592 8.93 1.463 0 2.953-.24 4.414-.754 6.955-2.438 10.614-10.053 8.176-17.006l-15.004-42.795c21.342-5.795 38.588-22.551 44.477-44.713l14.57-54.847a63.056 63.056 0 001.772-22.803zM199.382 26.685h24.016V44.55h-24.016V26.685zm-28.819 282.001a5.865 5.865 0 01-5.865 5.865H122.76a5.867 5.867 0 01-5.754-4.725l-4.693-23.66a5.872 5.872 0 011.221-4.863 5.872 5.872 0 014.533-2.143H164.7a5.865 5.865 0 015.865 5.865l-.002 23.661zm139.905-22.52l-4.691 23.66a5.87 5.87 0 01-5.754 4.725h-41.939a5.865 5.865 0 01-5.866-5.865v-23.66a5.865 5.865 0 015.866-5.864h46.632c1.756 0 3.42.786 4.535 2.144a5.866 5.866 0 011.217 4.86zM100.39 220.76l8.652-82.537c2.502-23.869 22.627-41.994 46.625-41.994h111.432c23.998 0 44.119 18.12 46.625 41.984l8.668 82.546H100.39v.001z"}})])
          )
        }
      }
    